import {useEffect, useState} from 'react';
import {Linkedin, X} from 'lucide-react';
import {BsGlobe, BsInstagram, BsTelegram, BsTelephone, BsCopy} from "react-icons/bs";
import {message, Popover} from "antd";
import './SocialButtons.css';

const SocialButtons = ({vertical = false}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showPhone, setShowPhone] = useState(false);
    const phoneNumber = "+998 90 123 45 67";

    // The sidebar changed shape under the popover, so it would point at a stale spot
    useEffect(() => {
        setShowPhone(false);
    }, [vertical]);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
        setShowPhone(false);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(phoneNumber);
        message.success("Phone number copied!")
    };

    const phoneContent = (
        <div className="phone-popup">
            <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="phone-number">
                {phoneNumber}
            </a>
            <button onClick={handleCopy} className="popup-btn" aria-label="Copy">
                <BsCopy size={14}/>
            </button>
        </div>
    );

    return (
        <div className={`social-buttons ${isExpanded ? 'social-buttons--expanded' : ''}`}>
            <button
                className="main-button"
                onClick={toggleExpand}
                aria-label="Toggle social media links"
                aria-expanded={isExpanded}
            >
                <span className="main-button__icon">
                    {isExpanded ? <X size={16}/> : <BsGlobe size={16}/>}
                </span>
            </button>

            <div className="social-icons" aria-hidden={!isExpanded}>
                <a
                    href="https://www.instagram.com/bctechnologies/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon instagram"
                    aria-label="Instagram"
                    tabIndex={isExpanded ? 0 : -1}
                >
                    <BsInstagram size={15}/>
                </a>

                <a
                    href="https://t.me/bct_uz"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon telegram"
                    aria-label="Telegram"
                    tabIndex={isExpanded ? 0 : -1}
                >
                    <BsTelegram size={15}/>
                </a>

                <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon linkedin"
                    aria-label="LinkedIn"
                    tabIndex={isExpanded ? 0 : -1}
                >
                    <Linkedin size={15}/>
                </a>

                <Popover
                    content={phoneContent}
                    trigger="click"
                    placement={vertical ? 'right' : 'top'}
                    open={isExpanded && showPhone}
                    onOpenChange={setShowPhone}
                    overlayClassName="phone-popover"
                >
                    <button
                        className={`social-icon call ${showPhone ? 'is-active' : ''}`}
                        aria-label="Call"
                        tabIndex={isExpanded ? 0 : -1}
                    >
                        <BsTelephone size={14}/>
                    </button>
                </Popover>
            </div>
        </div>
    );
};

export default SocialButtons;
